<div class="layout">

  <!-- template slot / for menu -->
  <div class="layout__side-menu" *ngIf="hasSideMenu">
    <ng-content select="layout-side-menu"></ng-content>
  </div>

  <!-- template slot / for content -->
  <div class="layout__content">

    <div class="container">
      <ng-content select="layout-content"></ng-content>
    </div>

  </div>

</div>
